import React from 'react';
import classes from './TabList.module.scss';
import { WMSkeleton, WMTabList } from '@walkme/wm-ui';

import clsx from 'clsx';
import { getFormatNumberString } from '../../helpers/getFormatNumberString';

const TabList = ({ tabs, value, onChange, renderTabLabel, isTabDisabled, getTabBadge, children = null, noBorderAndMargins = false }: $TSFixMe) => {
    return (
        <div className={clsx(classes.root, { [classes.noBorderAndSideMargins]: noBorderAndMargins })}>
            <WMTabList
                className={classes.tabs}
                classes={{ scroller: classes.scroller }}
                TabIndicatorProps={{ hidden: false, style: { height: 1, background: 'var(--wmPrimary)' } }}
                indicatorColor="primary"
                value={value}
                onChange={onChange}
            >
                {tabs.map((tab: string) => ({
                    panel: null,
                    value: tab,
                    label: (
                        <div className={classes.label}>
                            <span className={classes.labelText}>{renderTabLabel?.(tab) ?? tab}</span>
                            {(() => {
                                const count = getTabBadge ? getTabBadge?.(tab) : 0;

                                return typeof count === 'number' ? (
                                    <div className={classes.badge} data-testid={`${tab}-tab-counter`}>
                                        {getFormatNumberString(count)}
                                    </div>
                                ) : (
                                    <WMSkeleton height={16} width={18} variant={'circle'} />
                                );
                            })()}
                        </div>
                    ),

                    className: clsx(classes.tab, { [classes.selectedTab]: tab === value }),
                    disabled: isTabDisabled(tab),
                    'data-testid': `${tab}-tab-trigger`
                }))}
            </WMTabList>

            {children}
        </div>
    );
};

export default TabList;
